import React, { useState, useEffect } from "react";
import { compose } from "react-apollo";
import { withQuery } from "containers/withQuery";
import styled from "styled-components";
import Input from "components/Input/Input";
import Modal from "components/Modal/Modal";
import Field from "components/Field/Field";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import Footer from "../modalComponents/Footer";
import { sensorMaterialTypes } from "../enumTypes";
import { Select } from "../CustomSelect";
import { SENSOR_MATERIAL_TYPES_QUERY } from "../generalRegisterQueries";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 35px;
`;

const buildInitialState = ({ name, materialType, unit }) => ({
  name: name || "",
  unit: unit || "",
  materialType: materialType
    ? { value: materialType, label: sensorMaterialTypes[materialType] }
    : null,
});

const SensorModal = ({
  name,
  materialType,
  unit,
  snackbarContext,
  onSave,
  isOpen,
  toggleModal,
  title,
  __type: {
    states
  },
}) => {
  const [form, setForm] = useState(
    buildInitialState({ name, materialType, unit })
  );

  const sensorOptions = [
    {
      value: null,
      isDisabled: true,
    },
    ...states.map(({ name: type }) => ({
      value: type,
      label: sensorMaterialTypes[type],
    })),
    {
      label: "Nenhum",
      value: null,
    },
  ];

  useEffect(() => {
    if (isOpen) {
      setForm(buildInitialState({ name, materialType, unit }));
    }
  }, [isOpen, name, materialType, unit]);

  const updateField = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const onSaveEntry = () => {
    if (!form.name.trim()) {
      snackbarContext.setNotificationTimeOut(
        Color.danger,
        "O campo nome é obrigatório"
      );
      return;
    }

    onSave({
      ...form,
      materialType: form.materialType ? form.materialType.value : null,
    });
  };

  const isInvalid = !form.name.trim();

  return (
    <Modal
      isOpen={isOpen}
      toggleModal={toggleModal}
      size="md"
      title={title}
      footer={(
        <Footer
          onConfirm={onSaveEntry}
          disabled={isInvalid}
        />
      )}
    >
      <Row>
        <Field title="Nome" width="96%">
          <Input
            name="name"
            value={form.name}
            onChange={updateField}
          />
        </Field>
      </Row>

      <Row>
        <Field title="Tipo" width="96%">
          <Select
            name="materialType"
            placeholder="Escolha..."
            value={form.materialType}
            onChange={updateField}
            options={sensorOptions}
          />
        </Field>
      </Row>

      <Row>
        <Field title="Unidade" width="96%">
          <Input
            name="unit"
            value={form.unit}
            onChange={updateField}
          />
        </Field>
      </Row>
    </Modal>
  );
};


export default compose(
  withQuery({
    query: SENSOR_MATERIAL_TYPES_QUERY
  }),
  withSnackbarConsumer
)(SensorModal);
